export var BadgePriority;
(function (BadgePriority) {
    BadgePriority["default"] = "default";
    BadgePriority["light"] = "light";
    BadgePriority["primary"] = "primary";
    BadgePriority["secondary"] = "secondary";
})(BadgePriority || (BadgePriority = {}));
/** *************************/
//# sourceMappingURL=types.js.map